module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('emailPlaceholder')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'input': true, 'danger-border': _vm.errors.has('email') || !!_vm.emailErrorMessage
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('emailPlaceholder'),
      "name": "email",
      "id": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "change": _vm.validateEmail,
      "blur": [_vm.validateEmail, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [(_vm.errors.has('email') && _vm.showError.email) ? _c('span', [_vm._v(_vm._s(_vm.errors.first('email')))]) : _c('span', [_vm._v(_vm._s(_vm.emailErrorMessage))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t('passwordPlaceholder')))]), _vm._v(" "), (!_vm.isShowPwd) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6|max:20'),
      expression: "'required|min:6|max:20'"
    }],
    class: {
      'input pwd': true, 'danger-border': _vm.errors.has('password')
    },
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": _vm.$t('passwordPlaceholder'),
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doRegister($event)
      },
      "blur": [function($event) {
        _vm.showError.password = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowPwd) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6|max:20'),
      expression: "'required|min:6|max:20'"
    }],
    class: {
      'input pwd': true, 'danger-border': _vm.errors.has('password')
    },
    attrs: {
      "type": "text",
      "name": "password",
      "id": "password",
      "placeholder": _vm.$t('passwordPlaceholder'),
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doRegister($event)
      },
      "blur": [function($event) {
        _vm.showError.password = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "show-pwd",
    on: {
      "click": _vm.showPwd
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPwd),
      expression: "isShowPwd"
    }],
    attrs: {
      "src": "/static/img/dashboard/ic_eye.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowPwd),
      expression: "!isShowPwd"
    }],
    attrs: {
      "src": "/static/img/dashboard/ic_eye_off.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [(_vm.errors.has('password') && _vm.showError.password) ? _c('span', [_vm._v(_vm._s(_vm.errors.first('password')))]) : _vm._e()])]), _vm._v(" "), _c('invitation-code', {
    model: {
      value: (_vm.invitationCode),
      callback: function($$v) {
        _vm.invitationCode = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "invitationCode"
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('button', {
    staticClass: "form-submit line-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doRegister
    }
  }, [_vm._v(_vm._s(_vm.$t('signUp')))]) : _vm._e(), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "sign-in",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm.$t('signIn')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-229ca74b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/registerform/EmailRegister.vue
// module id = 1278
// module chunks = 1